import React from "react";
import pushpanjali from "../assets/case-studies/pushpanjali-cs.png";

export default function PushpanjaliCaseStudy() {
  return (
    <div className="cs-pages">
      <img src={pushpanjali} alt="Pushpanjali Dresses" width="80%" />
    </div>
  );
}
